// extracted by mini-css-extract-plugin
export default {"loginWrapper":"ResetPassword_loginWrapper__85en4","loginBlock":"ResetPassword_loginBlock__OwUA7"};